import * as TYPES from './constants';
import {
  requestSuperUserQuikFyndData,
  receiveSuperUserQuikFyndData,
  handleSuperUserQuikFyndDataError,
} from './actions';

import {Services} from 'core';

import {API} from 'config/superuser.config';

const initialState = {
  data: null,
  request: null,
  error: null,
};

const services = new Services();
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_SUPER_USER_QUIKFYND_DATA:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_SUPER_USER_QUIKFYND_DATA:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.SUPER_USER_QUIKFYND_DATA_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchSuperUserQuikFyndData = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();

  dispatch(requestSuperUserQuikFyndData());
  let endpoint = `${API.administration.institutions_list}`;
  try {
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveSuperUserQuikFyndData(res));
      })
      .catch(err => console.log(err));
  } catch (err) {
    console.log(err);
    dispatch(handleSuperUserQuikFyndDataError(err));
  }
};
